import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import useAxios from 'hooks/useAxios';
import TaskBoardTable from './components/TaskBoardTable';

const TaskBoard = () => {
    const API = useAxios();
    return (
        <div>
            <Container fluid className='my-3'>
                <Card className='border-0 shadow-top'>
                    <CardBody className='pt-0'>
                        <ErrorBoundary>
                            <TaskBoardTable />
                        </ErrorBoundary>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );

}

export default TaskBoard;